export default __webpack_public_path__ + "static/media/DE-DriverApp-Logo-White.fa75b217.png";